import { render, staticRenderFns } from "./AIChat_Step_2.vue?vue&type=template&id=7c38b2e0&scoped=true"
import script from "./AIChat_Step_2.vue?vue&type=script&lang=js"
export * from "./AIChat_Step_2.vue?vue&type=script&lang=js"
import style0 from "./AIChat_Step_2.vue?vue&type=style&index=0&id=7c38b2e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c38b2e0",
  null
  
)

export default component.exports